var map = {
	"./admin.service": [
		7347,
		[]
	],
	"./admin.service.js": [
		7347,
		[]
	],
	"./common.service": [
		2925,
		[]
	],
	"./common.service.js": [
		2925,
		[]
	],
	"./jbuser.service": [
		8115,
		[
			115
		]
	],
	"./jbuser.service.js": [
		8115,
		[
			115
		]
	],
	"./resellers.service": [
		7035,
		[]
	],
	"./resellers.service.js": [
		7035,
		[]
	],
	"./student.service": [
		5195,
		[
			195
		]
	],
	"./student.service.js": [
		5195,
		[
			195
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2326;
module.exports = webpackAsyncContext;